import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from "@angular/core";
import { CounterController } from "../counter-store/counter-controller.service";
import { IonBadge, IonButtons } from "@ionic/angular/standalone";
import { TranslocoPipe } from "@jsverse/transloco";
import { Router } from "@angular/router";
import { FeedbackHistoryControllerService } from "src/app/feedbacks/feedback-history/store/feedback-history-controller.service";
import { FeedbackArchiveControllerService } from "src/app/feedbacks/feedback-archive/store/feedback-archive-controller.service";
import { environment } from "src/environments/environment";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { fromEvent } from "rxjs";

@Component({
    selector: 'pf-counter',
    templateUrl: './counter.component.html',
    styleUrl: './counter.component.scss',
    imports: [IonButtons, IonBadge, TranslocoPipe ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CounterComponent {
    private readonly counterController = inject(CounterController)
    private readonly router = inject(Router)
    private readonly historyController = inject(FeedbackHistoryControllerService)
    private readonly archiveController = inject(FeedbackArchiveControllerService)
    readonly isMobile = signal(environment.isApp)
    readonly showLabels = input(true)

    readonly unreadCount = this.counterController.unreadCount
    readonly unreadMessagesCount = this.counterController.unreadMessagesCount
    readonly unreadClosedMessagesCount = this.counterController.unreadClosedMessagesCount

    readonly unreadCountLabel = computed(() => this.toBadgeLabel(this.unreadCount()))
    readonly unreadMessagesCountLabel = computed(() => this.toBadgeLabel(this.unreadMessagesCount()))
    readonly unreadClosedMessagesCountLabel = computed(() => this.toBadgeLabel(this.unreadClosedMessagesCount()))

    private toBadgeLabel(count: number): string {
        return count > 99 ? '99+' : `${count}`
    }
    readonly isAdministrator = this.counterController.isAdministrator
    readonly isManagerOrServiceDesk = this.counterController.isManagerOrServiceDesk
    readonly isManagerOrReporter = this.counterController.isManagerOrReporter

        constructor () {
        fromEvent(window, 'resize').pipe(takeUntilDestroyed()).subscribe(() => {
            this.checkScreenSize()
        })
        this.checkScreenSize()
    }

    checkScreenSize() {
                this.isMobile.set(environment.isApp)
    }


        goToUnreadList() {
        this.historyController.updateSearch({
            status: 'OPEN',
            onlyUnreadFeedback: true,
            onlyUnreadMessages: false,
        })
        this.router.navigate(['/feedbacks/history'])
    }

    goToUnreadMessagesList () {
        this.historyController.updateSearch({
            status: 'OPEN',
            onlyUnreadFeedback: false,
            onlyUnreadMessages: true,
        })
        this.router.navigate(['/feedbacks/history'])
    }

    goToUnreadClosedMessagesList () {
        this.archiveController.updateSearch({
            status: 'CLOSED',
            onlyUnreadFeedback: false,
            onlyUnreadMessages: true,
        })
        this.router.navigate(['/feedbacks/archive'])
    }
}